<!-- 抽奖页面2 -->
<template>
<div class="out-container">
  <div class="award-open-container">
    <div id="scratch">
      <div class="report-cover" @touchstart="showReportPopup" @click="showReportPopup" v-if="needReport"></div>
      <div v-if="!awardLog && !canDrawAward" id="card" class="award-draw-btn"  @click="toReceive">{{ awardTitle }}</div>
      <template v-else-if="awardLog">
        <div v-if="awardLog.award_type === 3" id="card" class="award-draw-btn">{{ awardLog.award_name }}</div>
        <div v-else @click="takeAward" class="award-wrapper" id="card">
          <p class="award-title">{{awardLog.award_name}}</p>
          <p v-if="awardLog.award_type!== 3">点击领取</p>
        </div>
      </template>
      <div v-else-if="isNotAwarded" id="card" class="award-wrapper" @click="sendCall">
        <!-- <p class="award-title">小红包跑丢了</p>
        <p>请拨打400电话找回</p> -->
        <p class="award-title">谢谢惠顾</p>
      </div>
      <div v-else id="card" class="award-draw-btn">{{awardTitle}}</div>

    </div>
    <!-- <div class="footer-wrapper">
      <img class="footer-img" src="../../assets/img/img_qingyun_footer_text.png">
    </div> -->
    <div class="bottom-tab">
      <div class="bottom-item">
        <img src="../../assets/icon/icon_3_slash.png" />
        <span>扫码抽奖</span>
      </div>
      <div class="bottom-item" @click="toResult">
        <img src="../../assets/icon/icon_3_slash.png" />
        <span>防伪验真</span>
      </div>
      <div class="bottom-item" @click="toCreditStore">
        <img src="../../assets/icon/icon_3_slash.png" />
        <span>积分商城</span>
      </div>
    </div>
    <van-popup class="mp-popup" v-model="showMp">
      <p>长按二维码关注</p>
      <img src="../../assets/img/img_qrcode.png">
    </van-popup>
    <!--  举报弹窗 -->
    <van-popup position="bottom" class="report-popup" v-model="showReport">
      <flee-report @ignored="hideReportPopup" @submited="hideReportPopup"></flee-report>
    </van-popup>
  </div>
</div>
</template>

<script>
import Vue from 'vue'
import qs from 'qs'
import Config from '@/config/config'
import { mapGetters } from 'vuex'
import LuckyCard from '../../util/lucky-card'
import { Toast, NoticeBar, Dialog, Popup } from 'vant'
import FleeReport from '../qrcode/fleeReport'

Vue.use(Dialog).use(Toast).use(NoticeBar).use(Popup)

export default {
  name: 'AwardDraw2',
  data() {
    return {
      awardLog: null,
      awardTitle: '抽奖中',
      serial: '',
      showMp: false,
      showReport: false,
      needReport: false,
      canDrawAward: true,
      isNotAwarded: false,
      canRequest: true
    }
  },
  components: {
    FleeReport
  },
  computed: {
    ...mapGetters(['userInfo', 'location', 'qrcode', 'subscribe'])
  },
  created() {
    this.serial = this.$route.query.serial
  },
  mounted() {
    this.initFleeReport()
    this.init()
  },
  methods: {
    /**
     * 拨打400电话
     */
    sendCall() {
      window.location.href = 'tel://4000039990'
    },
    /**
     * 初始化
     * 判断是否还能够抽奖
     */
    init() {
      // 未关注公众号先去关注
      // if (!this.subscribe) {
      //   return Dialog.alert({
      //     message: '请先关注公众号再领奖'
      //   }).then(() => {
      //     return this.$router.push({ name: 'Subscribe' })
      //   })
      // }
      if (!this.qrcode) {
        return this.initLuckDraw()
      }
      if (this.qrcode.awarded) {
        this.canDrawAward = false
        this.awardTitle = '该瓶酒已过抽奖'
      } else {
        this.initLuckDraw()
      }
    },
    /**
     * 判断当前是否窜货
     * 若窜货，弹窗让用户反馈（用户未反馈过）
     */
    initFleeReport() {
      if (this.qrcode && this.qrcode.flee && !this.qrcode.report_count) {
        // 弹窗让用户反馈
        this.needReport = true
      }
    },
    /**
     * 显示举报弹窗
     */
    showReportPopup() {
      Dialog.alert({
        message: '该产品为正品'
      }).then(() => {
        this.showReport = true
      })
    },

    /**
     * 隐藏举报
     */
    hideReportPopup() {
      this.showReport = false
      this.needReport = false
    },
    /**
     * 初始化抽奖功能
     */
    initLuckDraw() {
      var that = this
      LuckyCard.case({ coverColor: '#c7c7c7', ratio: 0.3 }, function() {
        // 在这个回调函数里面，this是LuckyCard
        const luckyCard = this
        // 开奖，请求抽奖接口
        const params = {
          serial: that.serial,
          latitude: that.location.latitude,
          longitude: that.location.longitude,
          province: that.location.province,
          city: that.location.city,
          district: that.location.district,
          location: that.location.address,
          province_code: that.location.province_code,
          city_code: that.location.city_code,
          district_code: that.location.district_code
        }
        that.axios.post('/activity/award/draw/', qs.stringify(params)).then(function(res) {
          console.log(res)
          if (res.code === 3000) {
            that.awardTitle = '感谢您品鉴国花瓷西凤酒'
          }
          if (res.code === 4000) {
            // 设置已抽奖
            that.$store.dispatch('setAwarded')
            that.awardLog = res.data
          } else if (res.code === 4001) {
            that.awardTitle = '该瓶酒已抽过奖'
            // that.showReceiveText = true // 点击领取展示
          } else if (res.code === 4002) {
            // that.awardTitle = '抱歉，该瓶酒未中奖'
            that.isNotAwarded = true
            // that.awardTitle = '小红包跑丢了～请拨打400电话找回'
            that.awardTitle = '谢谢惠顾'
          }
          luckyCard.clearCover()
        }).catch(function(error) {
          console.log(error)
          that.$router.push({ name: 'QrcodeError', params: { errMsg: '系统错误' }})
        })
      })
      // canvas绘字
      var cover = document.getElementById('cover')
      var coverTmp = cover.getContext('2d')
      var str = '刮开图层 抽大奖'
      coverTmp.fillStyle = '#4a4a4a'
      coverTmp.font = '18px Arial'
      coverTmp.textBaseline = 'middle'
      // coverTmp.fillText('刮开图层 抽大奖', 64, 46)
      // 字动态居中
      coverTmp.fillText(str, (cover.width - coverTmp.measureText(str).width) / 2, 40 * cover.height / 80)
    },
    /**
     * 领取奖品
     * 如果奖品是红包，直接请求接口领取；如果奖品是实物，进到领奖页面
     * TODO 增加领取积分
     */
    takeAward() {
      // 防止重复点击
      if (!this.canRequest) {
        return
      }

      if (this.awardLog.award_type === 0) {
        this.$router.push({ path: '/user/award/receive', query: { logId: this.awardLog.id }})
        // 实物奖
      } else if (this.awardLog.award_type === 1) {
        // 领取虚拟奖品
        window.location.href = this.awardLog.award_url
      } else if (this.awardLog.award_type === 2) {
        // 红包
        var that = this
        this.canRequest = false
        var params = {
          id: this.awardLog.id
        }
        this.axios.post('/activity/award/receive/', qs.stringify(params)).then(function(res) {
          that.canRequest = true
          if (!res.code) {
            Dialog.alert({
              title: '提示',
              message: '红包已发放，请到微信消息里领取'
            }).then(() => {
              // 领取后跳转到积分商城
              if (this.userInfo.id) {
                const storeUrl = Config.creditStoreBaseUrl + '/?name=' + that.userInfo.nickname + '&gender=' + that.userInfo.gender +
                '&province=' + that.userInfo.province + '&city=' + that.userInfo.city + '&avatar=' + that.userInfo.avatar +
                '&userCode=' + that.userInfo.openid + '&appId=' + Config.creditStoreAppId + '&phone=' + that.userInfo.mobile
                window.location.href = storeUrl
              } else {
                that.$router.push({ path: '/' })
              }
            })
          } else {
            Toast(res.message)
          }
        }).catch(function(error) {
          console.log(error)
          that.canRequest = true
          Toast('红包领取失败')
        })
      } else {
        // TODO 增加积分领取
      }
    },

    /**
     * 跳转到防伪验证页面
     */
    toResult() {
      this.$router.replace({ path: '/qrcode/result', query: { serial: this.serial }})
    },
    toReceive() {
      this.$router.push({ path: '/user/award/log' })
    },
    toCreditStore() {
      if (this.userInfo.id) {
        const storeUrl = Config.creditStoreBaseUrl + '/?name=' + this.userInfo.nickname + '&gender=' + this.userInfo.gender +
        '&province=' + this.userInfo.province + '&city=' + this.userInfo.city + '&avatar=' + this.userInfo.avatar +
        '&userCode=' + this.userInfo.openid + '&appId=' + Config.creditStoreAppId + '&phone=' + this.userInfo.mobile
        window.location.href = storeUrl
      } else {
        this.$router.push({ path: '/' })
      }
    }
  }
}
</script>

<style>
@import '../../assets/style/lucky-card.css';
</style>

<style lang="scss" scoped>
.out-container {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  padding-bottom: 48px;
  overflow: hidden;
}
.award-open-container {
  width: 100%;
  height: 100%;
  background-image: url('../../assets/img/img_award_background3.png');
  background-size: 100% 100%;
  box-sizing: border-box;
  position: relative;
  // .award-wrapper {
  //   width: 330px;
  //   height: 273px;
  //   background-image: url('../../assets/img/img_award_wrapper1.png');
  //   background-size: contain;
  //   position: relative;
  //   text-align: center;
  //   top: 200px;
  //   left: 22.5px;
  //   p {
  //     width: 100%;
  //     position: absolute;
  //     bottom: 20px;
  //     color: #fba924;
  //     font-size: 12px;
  //     font-weight: 900;
  //     letter-spacing: 0;
  //   }
  // }
  .footer-wrapper {
    width: 320px;
    height: 68px;
    position: absolute;
    bottom: 25px;
    left: 27.5px;
    img {
      width: 100%;
      height: 100%;
    }
  }
  #scratch{
    width: 260px;
    height: 80px;
    position: relative;
    top: 180px;
    left: 57.5px;
    .report-cover {
      position: absolute;
      left: 0;
      top: 0;
      width: 260px;
      height: 80px;
      z-index: 10;
    }
    .award-draw-btn {
      height: 100%;
      border-radius: 5px;
      color: #d60d09;
      font-weight: 600;
      font-size: 24px;
      line-height: 80px;
      text-align: center;
      background: #faf9dd;
      overflow: hidden;
      text-overflow:ellipsis;
      white-space: nowrap;
    }
    .award-wrapper {
      position: absolute;
      left: 0;
      top: 0;
      width: 260px;
      height: 80px;
      z-index: 100;
      border-radius: 5px;
      background: #faf9dd;
      text-align: center;
      box-sizing: border-box;
      padding: 5px 0;
      p {
        line-height: 35px;
        font-size: 16px;
        font-weight: 400;
        color: #d60d09;
      }
      .award-title {
        font-size: 21px;
        font-weight: 600;
        overflow: hidden;
        text-overflow:ellipsis;
        white-space: nowrap;
      }
    }
    .award-tips {
      position: absolute;
      left: 0;
      top: 0;
      width: 260px;
      height: 80px;
      z-index: 100;
      text-align: center;
      p {
        height: 80px;
        line-height: 80px;
        font-size: 16px;
        color: #4A4A4A;
        letter-spacing: 0;
      }
    }
  }
  @media screen and (min-height: 710px) {
    #scratch{
      top: 190px;
    }
    .award-wrapper {
      top: 190px;
    }
  }
  .report-popup {
    width: 100%;
    height: 100%;
  }
  @media screen and (max-height: 610px) {
    .award-wrapper {
      width: 310px;
      height: 257px;
      top: 200px;
      left: 32.5px;
      p {
        bottom: 45px;
      }
    }
    .footer-wrapper {
      width: 310px;
      height: 60px;
      position: absolute;
      bottom: 15px;
      left: 32.5px;
    }
  }
  // // iphoneX, iphoneXs
  // @media only screen and (device-width: 375px) and (device-height: 812px) and (-webkit-device-pixel-ratio: 3) {
  //   #scratch{
  //     top: 280px;
  //   }
  //   .award-wrapper {
  //     top: 280px;
  //   }
  // }

  // // iphone Xs Max
  // @media only screen and (device-width: 414px) and (device-height: 896px) and (-webkit-device-pixel-ratio:3) {
  //   #scratch{
  //     top: 280px;
  //   }
  //   .award-wrapper {
  //     top: 280px;
  //   }
  // }

  // // iphone XR
  // @media only screen and (device-width: 414px) and (device-height: 896px) and (-webkit-device-pixel-ratio:2) {
  //   #scratch{
  //     top: 280px;
  //   }
  //   .award-wrapper {
  //     top: 280px;
  //   }
  // }
}

</style>



// WEBPACK FOOTER //
// src/pages/award/draw2.vue